//ページ内リンク
$(window).on('load', function() {
  let headerHeight = $('header').outerHeight();
  let urlHash = location.hash;
  if (urlHash) {
    let position = $(urlHash).offset().top - headerHeight;
    $('html, body').animate({ scrollTop: position }, 0);
  }
});

jQuery(function ($) {

//
  $(".kv-slider").slick({
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
  });

  //ページ内リンク
  $('.page-links').on('click', function () {
    let time = 400;
    let header = $('header').height();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({
      scrollTop: targetY
    }, time, 'swing');
    return false;
  });

  //ハンバーガーメニュー
  $('.hamburger').on('click',function(){
    $('header').toggleClass('is-open');
  });

  $('.js-close').on('click',function(){
    $('header').removeClass('is-open');
  });

  $('.header-bg').on('click',function(){
    $('header').removeClass('is-open');
  });

  //ページトップ
  $('.to-top').hide();
  //スクロールした際の動きを関数でまとめる
  function PageTopAnime() {
    var scroll = $(window).scrollTop();
    if (scroll >= 200){//上から200pxスクロールしたら
      $('.to-top').fadeIn();
    }else{
      $('.to-top').fadeOut();
    }
  }

  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/
  });
  $('.to-top').on('click',function () {
    $('body, html').animate({
        scrollTop: 0
    }, 500);
    return false;
  });

  //accordion
  $('.accordion-content').hide();
  $('.accordion-head').on('click', function(){
    $(this).next('.accordion-content').slideToggle();
    $(this).toggleClass('is-active');
  });
});
